import * as API from './api'
import * as Types from './Types'
import * as Constants from '../helpers/Constants'
import * as Functions from '../helpers/Functions'
import * as Strings from './strings'

export function tryMakeBooking(token, data, language, alert, offlineMode) {
  const loadingId = generateId()

  if (offlineMode) {
    return dispatch => {
      const booking = {
        ...data,
        id: generateId(),
        date: Functions.parseDate(data.date)
      }

      dispatch({
        type: Types.MAKE_BOOKING_SUCCESS,
        payload: booking,
        loadingId
      })
    }
  }

  return dispatch => {
    dispatch({
      type: Types.MAKE_BOOKING,
      payload: data
    })

    API.makeBooking(token, data)
      .then(response => {
        dispatch({
          type: Types.MAKE_BOOKING_SUCCESS,
          payload: response.data.data,
          loadingId
        })
      })
      .catch(error => {
        let payload = { status: 500 }

        if (error.response && error.response.status === 400) {
          payload = { status: 400 }

          alert(
            Strings.default.MAX_BOOKINGS_REACHED[language],
            Strings.default.MAX_BOOKINGS_REACHED_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        } else if (error.response && error.response.status === 409) {
          payload = { status: 409, data: error.response.data }

          alert(
            Strings.default.LAUNDRY_TIME_OCCUPIED[language],
            Strings.default.LAUNDRY_TIME_OCCUPIED_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        } else {
          alert(
            Strings.default.INTERNAL_ERROR[language],
            Strings.default.INTERNAL_ERROR_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        }

        dispatch({
          type: Types.MAKE_BOOKING_FAILED,
          payload
        })
      })
  }
}

export function tryDeleteBooking(
  token,
  bookingId,
  language,
  alert,
  offlineMode
) {
  if (offlineMode) {
    return dispatch => {
      dispatch({
        type: Types.DELETE_BOOKING_SUCCESS,
        payload: bookingId
      })
    }
  }

  return dispatch => {
    dispatch({
      type: Types.DELETE_BOOKING,
      payload: bookingId
    })

    API.deleteBooking(token, bookingId)
      .then(() => {
        dispatch({
          type: Types.DELETE_BOOKING_SUCCESS,
          payload: bookingId
        })
      })
      .catch(() => {
        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )

        dispatch({
          type: Types.DELETE_BOOKING_FAILED,
          payload: bookingId
        })
      })
  }
}

export function tryGetLaundrySystem(token, language, alert, silentFailure = false) {
  return dispatch => {
    dispatch({
      type: Types.GET_LAUNDRY_SYSTEM
    })

    API.getLaundrySystem(token)
      .then(response => {
        dispatch({
          type: Types.GET_LAUNDRY_SYSTEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_LAUNDRY_SYSTEM_FAILED
        })

        if (!silentFailure) {
          alert(
            Strings.default.INTERNAL_ERROR[language],
            Strings.default.INTERNAL_ERROR_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        }
      })
  }
}

function generateId() {
  return Math.floor(Math.random() * 1000000 + 1) // This may generate a duplicate key but I deem the odds of that to be fairly low.
}



// WEBPACK FOOTER //
// ./src/actions/LaundryBookings.js